import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute4 = ({
  width = 504,
  height = 711,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 1236,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 504 711"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M1.34451,710.484C-8.50849,626.976 195.889,605.502 242.055,537.968C288.221,470.433 289.888,426.007 306.586,305.946C319.945,209.898 286.934,166.423 306.586,117.461C322.843,76.9571 367.313,21.7684 397.71,7.04661C435.706,-11.3557 387.155,18.5482 385.044,57.6532C383.356,88.9372 420.93,64.5541 452.594,57.6532C490.59,57.6532 480.036,93.0776 480.036,151.965C480.036,177.503 489.165,203.446 502.764,225"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M1.34451,710.484C-8.50849,626.976 195.889,605.502 242.055,537.968C288.221,470.433 289.888,426.007 306.586,305.946C319.945,209.898 286.934,166.423 306.586,117.461C322.843,76.9571 367.313,21.7684 397.71,7.04661C435.706,-11.3557 387.155,18.5482 385.044,57.6532C383.356,88.9372 420.93,64.5541 452.594,57.6532C490.59,57.6532 480.036,93.0776 480.036,151.965C480.036,177.503 489.165,203.446 502.764,225"
      />
    </svg>
  )
}

export default ExpeditionRoute4
